import { Euler, Matrix4 } from 'three';
import { degToRad } from '@/util';
import type { CatstackPlaneId } from '@/domain/anatomy/catstackPlane';
import { type ObjectNode, objectNode } from '@/lib/threeScene/nodes/object';

export type OverlayImageNode = ObjectNode<'overlay-plane'> & {
    planeId: CatstackPlaneId;
    source: HTMLCanvasElement | string | null;
    sourceVersion: number;
    image: HTMLImageElement | null;
    width: number;
    height: number;
};

export function overlayImageNode(planeId: CatstackPlaneId): OverlayImageNode {
    let transform: Matrix4;
    switch (planeId) {
        case 'coronal':
            transform = new Matrix4().makeRotationFromEuler(
                new Euler(degToRad(90), 0, 0),
            );
            break;
        case 'axial':
            transform = new Matrix4().makeRotationFromEuler(
                new Euler(degToRad(180), 0, 0),
            );
            break;
        case 'sagittal':
            transform = new Matrix4().makeRotationFromEuler(
                new Euler(degToRad(90), degToRad(90), 0),
            );
            break;
        default:
            transform = new Matrix4().makeRotationFromEuler(
                new Euler(degToRad(90), 0, 0),
            );
            break;
    }

    return {
        ...objectNode('overlay-plane', `overlay-plane-${planeId}`, { transform }),
        planeId,
        source: null,
        sourceVersion: 0,
        image: null,
        width: 0,
        height: 0,
    };
}
